import { AxiosPromise } from "axios";

export const emptySubmitChangeFunc = (): AxiosPromise<server.dto.ApiResponse> => {
  return new Promise(resolve => {
    resolve({
      data: {
        errors: [],
        hasErrors: false,
      },
      status: 200,
      statusText: "OK",
      headers: undefined,
      config: undefined,
      request: undefined,
    });
  });
}
